<!-- <h2 mat-dialog-title>Job Application Form</h2> -->
<form
  [formGroup]="candidateForm"
  (ngSubmit)="onSubmit()"
  fxLayout="column"
  fxLayoutGap="16px"
>
  <mat-label>{{ "TITLE" | translate }}</mat-label>
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "FULL_NAME" | translate }}</mat-label>
    <input matInput formControlName="name" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "BIRTH_DATE" | translate }}</mat-label>
    <input matInput type="date" formControlName="birthDate" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "BIRTH_PLACE" | translate }}</mat-label>
    <input matInput formControlName="birthPlace" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "CERTIFICATE" | translate }}</mat-label>
    <input matInput formControlName="certificate" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "CERTIFICATE_DATE" | translate }}</mat-label>
    <input matInput type="date" formControlName="certificateDate" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "ADDRESS" | translate }}</mat-label>
    <input matInput formControlName="address" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "EMAIL" | translate }}</mat-label>
    <input matInput type="email" formControlName="email" required />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "HOME_PHONE" | translate }}</mat-label>
    <input matInput type="tel" formControlName="homePhone" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "PORTABLE_PHONE" | translate }}</mat-label>
    <input matInput type="tel" formControlName="portablePhone" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ "JOB" | translate }}</mat-label>
    <mat-select formControlName="job" required>
      <mat-option *ngFor="let job of domainJobOptions" [value]="job">{{
        job[language]
      }}</mat-option>
      <mat-option value="Other">{{ "OTHER_JOB" | translate }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    *ngIf="candidateForm.get('job')?.value === 'Other'"
    appearance="outline"
    class="full-width"
  >
    <mat-label>{{ "SPECIFY_OTHER_JOB" | translate }}</mat-label>
    <input matInput formControlName="otherJob" />
  </mat-form-field>

  <div class="full-width">
    <label
      ><strong>{{ "UPLOAD_CV" | translate }}</strong></label
    >
    <input
      #fileInput
      type="file"
      accept=".pdf"
      (change)="onFileSelected($event)"
      hidden
    />
    <button mat-stroked-button color="accent" (click)="fileInput.click()">
      {{ "CHOOSE_FILE" | translate }}
    </button>
    <div *ngIf="selectedFile">
      <mat-icon>check_circle</mat-icon> {{ selectedFile.name }}
    </div>
  </div>

  <!-- Action Buttons -->
  <div fxLayout="row wrap" fxLayoutAlign="end center" fxLayoutGap="10px">
    <button mat-button type="button" (click)="onClose()">
      {{ "CANCEL" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="!candidateForm.valid || !selectedFile"
    >
      {{ "SUBMIT" | translate }}
    </button>
  </div>
</form>
